// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    overflow: hidden;
    position: fixed;
    width: 100vw;
    height: 100vh;
    font-family: "Zen Maru Gothic", serif;
    font-weight: 500;
    font-style: normal;
}
body {
    margin: 0;
    /* font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
        "Helvetica Neue", sans-serif; */
    font-family: "Mochiy Pop One", sans-serif;
    font-weight: 400;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow: hidden;
    overflow-y: hidden;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.buttons {
    margin: 10%;
    text-align: center;
}

.btn-hover {
    width: 200px;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    margin: 20px;
    height: 55px;
    text-align: center;
    border: none;
    background-size: 300% 100%;

    border-radius: 50px;
    moz-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
}

.btn-hover:hover {
    background-position: 100% 0;
    moz-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
}

.btn-hover:focus {
    outline: none;
}

.btn-hover.color-1 {
    background-image: linear-gradient(to right, #25aae1, #40e495, #30dd8a, #2bb673);
    box-shadow: 0 4px 15px 0 rgba(49, 196, 190, 0.75);
}
.btn-hover.color-2 {
    background-image: linear-gradient(to right, #f5ce62, #e43603, #fa7199, #e85a19);
    box-shadow: 0 4px 15px 0 rgba(229, 66, 10, 0.75);
}
.btn-hover.color-3 {
    background-image: linear-gradient(to right, #667eea, #764ba2, #6b8dd6, #8e37d7);
    box-shadow: 0 4px 15px 0 rgba(116, 79, 168, 0.75);
}
.btn-hover.color-4 {
    background-image: linear-gradient(to right, #fc6076, #ff9a44, #ef9d43, #e75516);
    box-shadow: 0 4px 15px 0 rgba(252, 104, 110, 0.75);
}
.btn-hover.color-5 {
    background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
    box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
}
.btn-hover.color-6 {
    background-image: linear-gradient(to right, #009245, #fcee21, #00a8c5, #d9e021);
    box-shadow: 0 4px 15px 0 rgba(83, 176, 57, 0.75);
}
.btn-hover.color-7 {
    background-image: linear-gradient(to right, #6253e1, #852d91, #a3a1ff, #f24645);
    box-shadow: 0 4px 15px 0 rgba(126, 52, 161, 0.75);
}
.btn-hover.color-8 {
    background-image: linear-gradient(to right, #29323c, #485563, #2b5876, #4e4376);
    box-shadow: 0 4px 15px 0 rgba(45, 54, 65, 0.75);
}
.btn-hover.color-9 {
    background-image: linear-gradient(to right, #25aae1, #4481eb, #04befe, #3f86ed);
    box-shadow: 0 4px 15px 0 rgba(65, 132, 234, 0.75);
}
.btn-hover.color-10 {
    background-image: linear-gradient(to right, #ed6ea0, #ec8c69, #f7186a, #fbb03b);
    box-shadow: 0 4px 15px 0 rgba(236, 116, 149, 0.75);
}
.btn-hover.color-11 {
    background-image: linear-gradient(to right, #eb3941, #f15e64, #e14e53, #e2373f);
    box-shadow: 0 5px 15px rgba(242, 97, 103, 0.4);
}
.btn-hover.color-12 {
    background-image: linear-gradient(to right, rgb(228, 158, 74), rgb(247, 205, 154), rgb(247, 205, 154), rgb(247, 205, 154));
    box-shadow: 0 5px 15px rgba(242, 97, 103, 0.4);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,SAAS;IACT;uCACmC;IACnC,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;;IAE1B,mBAAmB;IACnB,oCAAoC;IAGpC,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IAGpC,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,+EAA+E;IAC/E,iDAAiD;AACrD;AACA;IACI,+EAA+E;IAC/E,gDAAgD;AACpD;AACA;IACI,+EAA+E;IAC/E,iDAAiD;AACrD;AACA;IACI,+EAA+E;IAC/E,kDAAkD;AACtD;AACA;IACI,+EAA+E;IAC/E,iDAAiD;AACrD;AACA;IACI,+EAA+E;IAC/E,gDAAgD;AACpD;AACA;IACI,+EAA+E;IAC/E,iDAAiD;AACrD;AACA;IACI,+EAA+E;IAC/E,+CAA+C;AACnD;AACA;IACI,+EAA+E;IAC/E,iDAAiD;AACrD;AACA;IACI,+EAA+E;IAC/E,kDAAkD;AACtD;AACA;IACI,+EAA+E;IAC/E,8CAA8C;AAClD;AACA;IACI,0HAA0H;IAC1H,8CAA8C;AAClD","sourcesContent":["html {\r\n    overflow: hidden;\r\n    position: fixed;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    font-family: \"Zen Maru Gothic\", serif;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n}\r\nbody {\r\n    margin: 0;\r\n    /* font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\r\n        \"Helvetica Neue\", sans-serif; */\r\n    font-family: \"Mochiy Pop One\", sans-serif;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    overflow: hidden;\r\n    overflow-y: hidden;\r\n}\r\n\r\ncode {\r\n    font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\r\n}\r\n\r\n.buttons {\r\n    margin: 10%;\r\n    text-align: center;\r\n}\r\n\r\n.btn-hover {\r\n    width: 200px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #fff;\r\n    cursor: pointer;\r\n    margin: 20px;\r\n    height: 55px;\r\n    text-align: center;\r\n    border: none;\r\n    background-size: 300% 100%;\r\n\r\n    border-radius: 50px;\r\n    moz-transition: all 0.4s ease-in-out;\r\n    -o-transition: all 0.4s ease-in-out;\r\n    -webkit-transition: all 0.4s ease-in-out;\r\n    transition: all 0.4s ease-in-out;\r\n}\r\n\r\n.btn-hover:hover {\r\n    background-position: 100% 0;\r\n    moz-transition: all 0.4s ease-in-out;\r\n    -o-transition: all 0.4s ease-in-out;\r\n    -webkit-transition: all 0.4s ease-in-out;\r\n    transition: all 0.4s ease-in-out;\r\n}\r\n\r\n.btn-hover:focus {\r\n    outline: none;\r\n}\r\n\r\n.btn-hover.color-1 {\r\n    background-image: linear-gradient(to right, #25aae1, #40e495, #30dd8a, #2bb673);\r\n    box-shadow: 0 4px 15px 0 rgba(49, 196, 190, 0.75);\r\n}\r\n.btn-hover.color-2 {\r\n    background-image: linear-gradient(to right, #f5ce62, #e43603, #fa7199, #e85a19);\r\n    box-shadow: 0 4px 15px 0 rgba(229, 66, 10, 0.75);\r\n}\r\n.btn-hover.color-3 {\r\n    background-image: linear-gradient(to right, #667eea, #764ba2, #6b8dd6, #8e37d7);\r\n    box-shadow: 0 4px 15px 0 rgba(116, 79, 168, 0.75);\r\n}\r\n.btn-hover.color-4 {\r\n    background-image: linear-gradient(to right, #fc6076, #ff9a44, #ef9d43, #e75516);\r\n    box-shadow: 0 4px 15px 0 rgba(252, 104, 110, 0.75);\r\n}\r\n.btn-hover.color-5 {\r\n    background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);\r\n    box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);\r\n}\r\n.btn-hover.color-6 {\r\n    background-image: linear-gradient(to right, #009245, #fcee21, #00a8c5, #d9e021);\r\n    box-shadow: 0 4px 15px 0 rgba(83, 176, 57, 0.75);\r\n}\r\n.btn-hover.color-7 {\r\n    background-image: linear-gradient(to right, #6253e1, #852d91, #a3a1ff, #f24645);\r\n    box-shadow: 0 4px 15px 0 rgba(126, 52, 161, 0.75);\r\n}\r\n.btn-hover.color-8 {\r\n    background-image: linear-gradient(to right, #29323c, #485563, #2b5876, #4e4376);\r\n    box-shadow: 0 4px 15px 0 rgba(45, 54, 65, 0.75);\r\n}\r\n.btn-hover.color-9 {\r\n    background-image: linear-gradient(to right, #25aae1, #4481eb, #04befe, #3f86ed);\r\n    box-shadow: 0 4px 15px 0 rgba(65, 132, 234, 0.75);\r\n}\r\n.btn-hover.color-10 {\r\n    background-image: linear-gradient(to right, #ed6ea0, #ec8c69, #f7186a, #fbb03b);\r\n    box-shadow: 0 4px 15px 0 rgba(236, 116, 149, 0.75);\r\n}\r\n.btn-hover.color-11 {\r\n    background-image: linear-gradient(to right, #eb3941, #f15e64, #e14e53, #e2373f);\r\n    box-shadow: 0 5px 15px rgba(242, 97, 103, 0.4);\r\n}\r\n.btn-hover.color-12 {\r\n    background-image: linear-gradient(to right, rgb(228, 158, 74), rgb(247, 205, 154), rgb(247, 205, 154), rgb(247, 205, 154));\r\n    box-shadow: 0 5px 15px rgba(242, 97, 103, 0.4);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
